import axios from "axios";
import { del, get, post, put, patch } from "./purchases_api_helper";
import * as url from "./purchases_url_helper";



/*************************** PURCHASES ******************************/

// get series categories
export const getPurchases = () => get(url.GET_PURCHASES);


// add serie categories
export const addNewPurchase = purchase => post(url.ADD_NEW_PURCHASE, {purchase: purchase});

// update series categories
//export const updateEventCategory = PURCHASE => put(url.UPDATE_PURCHASE, PURCHASE);
export const updatePurchase = purchase => patch(`${url.UPDATE_PURCHASE}/${purchase.uid}`,   { purchase: purchase  });

// delete series categories
//export const deleteEventCategory = eventCategory => del(url.DELETE_PURCHASE, { headers: { eventCategory } });
export const deletePurchase = purchase => del(`${url.DELETE_PURCHASE}/${purchase}`);



/*************************** INVOICES******************************/
// get invoices
export const getInvoices = () => get(url.GET_INVOICES);


// add serie categories
export const addNewInvoice = invoice => post(url.ADD_NEW_INVOICE, {invoice: invoice});

// update series categories
//export const updateEventCategory = PURCHASE => put(url.UPDATE_PURCHASE, PURCHASE);
export const updateInvoice = invoice => patch(`${url.UPDATE_INVOICE}/${invoice.uid}`,   { invoice: invoice  });

// delete series categories
//export const deleteEventCategory = eventCategory => del(url.DELETE_PURCHASE, { headers: { eventCategory } });
export const deleteInvoice = invoice => del(`${url.DELETE_INVOICE}/${invoice}`);









export {
  //getLoggedInUser,
  
  
};
